module.exports = __webpack_public_path__ + "static/alter.a63f149f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alter.jpg
// module id = 91
// module chunks = 35783957827783 82680274759079